import { Link } from "react-router-dom";
import { FaInstagram, FaTiktok } from "react-icons/fa6";
import { Logo } from "./Logo";
import { FOOTER_LINKS, SITE } from "../../data/site";
import { scrollToId } from "../../lib/scroll";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-950 text-slate-400 pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="[&_span]:!text-white [&_.text-violet-700]:!text-violet-400 [&_.text-slate-400]:!text-slate-500">
            <Logo />
          </div>
          <p className="text-sm leading-relaxed mt-5 max-w-sm">
            Auto-école indépendante au cœur de Chatou (78400). Code de la route, permis B, boîte automatique
            et conduite accompagnée dans toutes les Yvelines.
          </p>
          <div className="flex items-center gap-2.5 mt-6">
            {[
              { icon: FaInstagram, href: SITE.socials.instagram, id: "instagram" },
              { icon: FaTiktok, href: SITE.socials.tiktok, id: "tiktok" },
            ].map(({ icon: Icon, href, id }) => (
              <a
                key={id}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Bestconduite78 sur ${id}`}
                data-testid={`footer-social-${id}`}
                className="w-10 h-10 rounded-full border border-slate-800 flex items-center justify-center hover:text-white hover:bg-violet-700 hover:border-violet-700 transition-[color,background-color,border-color] duration-200"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-white font-heading font-bold text-sm uppercase tracking-wider">Liens utiles</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {FOOTER_LINKS.map((l) => (
              <li key={l.href}>
                <button
                  onClick={() => scrollToId(l.href)}
                  data-testid={`footer-link-${l.href.slice(1)}`}
                  className="hover:text-violet-400 transition-colors duration-200"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <Link to="/mentions-legales" data-testid="footer-link-mentions-legales" className="hover:text-violet-400 transition-colors duration-200">
                Mentions légales
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-heading font-bold text-sm uppercase tracking-wider">Nos partenaires</h3>
          <div className="mt-5 space-y-4">
            <a
              href="https://www.iledefrance.fr/toutes-les-actualites/cheque-permis-de-conduire-pour-les-18-25-ans-en-insertion-professionnelle"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-idf-link"
              aria-label="Région Île-de-France — Chèque permis de conduire pour les 18-25 ans"
              className="inline-block rounded-xl bg-white p-4 hover:-translate-y-1 hover:shadow-lg hover:shadow-violet-500/10 transition-[transform,box-shadow] duration-200"
            >
              <img
                src={SITE.idfLogo}
                alt="Logo de la Région Île-de-France — chèque permis de conduire 18-25 ans, partenaire de l'auto-école Bestconduite78 à Chatou"
                loading="lazy"
                className="h-12 w-auto object-contain"
                data-testid="footer-idf-logo"
              />
            </a>
            <a
              href={SITE.kalioUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-kalio-link"
              className="flex items-center gap-3.5 rounded-xl border border-slate-800 px-4 py-3.5 hover:border-violet-500 hover:bg-violet-950/40 transition-[border-color,background-color] duration-200 w-fit"
            >
              <img
                src={SITE.kalioLogo}
                alt="Logo Kalio — avis clients vérifiés de Bestconduite78"
                loading="lazy"
                className="w-10 h-10 rounded-full shrink-0"
              />
              <div>
                <p className="text-white text-sm font-bold leading-none">Kalio</p>
                <p className="text-[11px] text-slate-500 mt-1">Voir nos avis clients vérifiés</p>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-900 mt-14 pt-7 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <p data-testid="footer-address">{SITE.address}</p>
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Bestconduite78 — Auto-école à Chatou (78). Tous droits réservés.</p>
        <p>
          Réalisé par{" "}
          <a
            href="https://flytab.fr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit-flytab"
            className="font-bold text-violet-400 hover:text-violet-300 transition-colors duration-200"
          >
            flytab.fr
          </a>
        </p>
      </div>
    </div>
  </footer>
);
